import React from "react";
import { DesktopSidebar } from "./style";

export default ({ children }) => {
  return <DesktopSidebar>{children}</DesktopSidebar>;
};
